import { Copy } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { copyToClipboard } from '@/utils/clipboard'

export interface CopyableCodeProps {
  code: string
  /** Button label, e.g. "Copy command". Defaults to "Copy to clipboard". */
  copyLabel?: string
  className?: string
}

/** Read-only monospace snippet (URL, shell command) with a copy button. */
export function CopyableCode({ code, copyLabel, className }: CopyableCodeProps) {
  const { t } = useTranslation()
  return (
    <div className={cn('flex items-start gap-3 rounded-md border bg-muted/50 p-3', className)}>
      <code className="min-w-0 flex-1 self-center font-mono text-xs break-all whitespace-pre-wrap">{code}</code>
      <Button type="button" size="sm" variant="outline" className="shrink-0" onClick={() => copyToClipboard(code)}>
        <Copy />
        {copyLabel ?? t('common.copyToClipboard')}
      </Button>
    </div>
  )
}
